import PropTypes from 'prop-types';

import { generateQeId, Tag } from '@ctct/ui-react';

const propTypes = {
  'data-qe-id': PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  large: PropTypes.bool,
};

const defaultProps = {
  large: false,
};

const RecommendedBadge = (props) => {
  const { 'data-qe-id': qeId, large, t } = props;

  return (
    <span className="recommended-badge">
      <Tag
        kind="featured"
        size={large ? 'large' : 'default'}
        text={t('comparison-table.recommended')}
        data-qe-id={generateQeId(qeId, 'recommended-badge')}
      />
    </span>
  );
};

RecommendedBadge.propTypes = propTypes;
RecommendedBadge.defaultProps = defaultProps;
export default RecommendedBadge;
